module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "noindent_t_1"
  }, [_c('b', [_c('i', [_vm._v("Fall in love with this fan-favorite novella of family, romance and dogs from author Valerie Hansen.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_t1"
  }, [_vm._v("Single mom Krista Brody has no problem walking up to a neighbour’s door while searching for her son’s runaway puppy, Puddles. But the stranger who opens the door is very familiar…")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_t1"
  }, [_vm._v("Mark Vanbruger hasn’t seen Krista in years, but now they’re living in the same small town. They missed a chance at romance years ago—could a matchmaking puppy help them find happiness as a family now?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_t1"
  }, [_c('i', [_vm._v("Originally published in 2003.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76810737","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780369700407_BCC.vue
// module id = 57
// module chunks = 0